import Store from './Store';

export default Store;



// WEBPACK FOOTER //
// ./src/scenes/Stores/components/Store/index.ts